import { appendMode, REQUEST_SIZE } from 'constants/general';
import fetch from 'features/common/fetch';
import { generateCommonFetchActions } from 'utils/redux';

import {
	appendBruttoProductionTeamActivities,
	appendMyTeam,
	setBruttoProductionTeamActivities,
	setInfoGraphicsData,
	setLeadsSummary,
	setMyTeam,
} from './slice';

export const loadMyTeamData =
	({ body, queryParams }, append) =>
	(dispatch) => {
		dispatch(
			fetch.actions.get(fetch.constants.urls.myTeamSummary, {
				body,
				queryParams,
				onSuccess: [
					(response) => () => {
						const body = response?.body;

						if (append) {
							dispatch(appendMyTeam(body));
						} else {
							dispatch(setMyTeam(body));
						}
					},
				],
			}),
		);
	};

export const fetchMyTeamSummary =
	(page = 0) =>
	(dispatch) => {
		const queryParams = { size: REQUEST_SIZE, page };
		dispatch(loadMyTeamData({ queryParams }), appendMode.SET);
	};

export const {
	loadMore: loadMoreMyTeam,
	loadPage: loadPageMyTeam,
	reload: reloadMyTeam,
} = generateCommonFetchActions(loadMyTeamData, fetch.constants.urls.myTeamSummary);

export const loadBruttoProduction =
	({ body, queryParams }, append) =>
	(dispatch) => {
		dispatch(
			fetch.actions.get(fetch.constants.urls.bruttoProduction, {
				body,
				queryParams,
				onSuccess: [
					(response) => () => {
						const body = response?.body;

						if (append) {
							dispatch(appendBruttoProductionTeamActivities(body));
						} else {
							dispatch(setBruttoProductionTeamActivities(body));
						}
					},
				],
			}),
		);
	};

export const fetchBruttoProduction =
	(page = 0) =>
	(dispatch) => {
		const queryParams = { size: REQUEST_SIZE, page };
		dispatch(loadBruttoProduction({ queryParams }), appendMode.SET);
	};

export const {
	loadMore: loadMoreBruttoProduction,
	loadPage: loadPageBruttoProduction,
	reload: reloadBruttoProduction,
} = generateCommonFetchActions(loadBruttoProduction, fetch.constants.urls.bruttoProduction);

export const fetchStatisticsTasksSummary = (selectedSeller) => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.statisticsTasksSummary, {
			queryParams: { subordinateLogin: selectedSeller?.login },
			onSuccess: [
				(response) => () => {
					const body = response?.body;
					dispatch(setInfoGraphicsData({ tasks: body }));
				},
			],
		}),
	);
};

export const fetchStatisticsContactsSummary = (selectedSeller) => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.contactsSummary, {
			queryParams: { subordinateLogin: selectedSeller?.login },
			onSuccess: [
				(response) => () => {
					const body = response?.body;
					dispatch(setInfoGraphicsData({ contacts: body }));
				},
			],
		}),
	);
};

export const fetchStatisticsProductionSummary = (selectedSeller) => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.productionSummary, {
			queryParams: { subordinateLogin: selectedSeller?.login },
			onSuccess: [
				(response) => () => {
					const body = response?.body;
					dispatch(setInfoGraphicsData({ production: body }));
				},
			],
		}),
	);
};

export const fetchInfoGraphicsData = (selectedSeller) => (dispatch) => {
	dispatch(fetchStatisticsTasksSummary(selectedSeller));
	dispatch(fetchStatisticsContactsSummary(selectedSeller));
	dispatch(fetchStatisticsProductionSummary(selectedSeller));
};

export const fetchLeadsSummary = (selectedSeller) => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.leadsSummary, {
			queryParams: { subordinateLogin: selectedSeller?.login },
			onSuccess: [
				(response) => () => {
					const body = response?.body;
					dispatch(setLeadsSummary(body));
				},
			],
		}),
	);
};
